import { Component, ElementRef, NgZone, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { GoogleCustomer } from '../../Model/googlecustomer';
import { WebOrderMinimumDateTimeSetup } from '../../Model/web-order-minimum-date-time-setup';
import { ProductOrderSummary } from '../../Model/product-order-summary';
import { GstSaleInvCumBosDto } from '../../Model/gst-sale-inv-cum-bos-dto';
import { FormsModule, ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { WebOrderLocationSetup } from '../../Model/web-order-location-setup';
import { Subscription } from 'rxjs';
import { LocalStorageService } from '../../services/local-storage.service';
import { ApiFactoryEndPoints } from '../../common/api-factory-end-points';
import { ToastService } from '../../services/toast.service';
import { ProductService } from '../../services/product.service';
import { Router, RouterLink } from '@angular/router';
import { AppConfigService } from '../../services/app-config.service';
import { CustomerDeliveryAddress } from '../../Model/customer-delivery-address';
import { ProductOrderSummaryServiceService } from '../../services/product-order-summary-service.service';
import { State } from '../../Model/state';
import { NameWithIdDto } from '../../Model/name-with-id-dto';
import { AddressService } from '../../services/address.service';
import { CommonModule } from '@angular/common';
import { LucideAngularModule } from 'lucide-angular';
import { GoogleMapsModule } from '@angular/google-maps';
import { HeaderComponent } from '../../components/header/header.component';
import { CommonExternalModule } from '../../common/common-external-module';

@Component({
  selector: 'app-product-delivery-address',
  standalone: true,
  imports: [CommonExternalModule, HeaderComponent],
  templateUrl: './product-delivery-address.component.html',
  styleUrl: './product-delivery-address.component.css'
})

export class ProductDeliveryAddressComponent implements OnInit, OnDestroy {

  createSetUpForm: UntypedFormGroup;
  refNo: number;
  customerName: string;
  contactNo: number;
  pincode: number;
  cityCode: number;
  stateId: number;
  districtId: number;
  address: string;
  email: string;
  plot: string;
  locality: string;
  street: string;
  landMark: string;
  latitude: string;
  longitude: string;
  deliveryDate: Date;
  deliveryTime: string;
  stateName: string;
  cityName: string;
  currentUrl: string;
  companyCode: number;
  deliveryPinCode: number;
  toogle: number;
  showDeliveryDiv: boolean = false;

  googleCustomer: GoogleCustomer;
  webOrderMinimumDateTimeList: WebOrderMinimumDateTimeSetup;
  deliveryLocation: WebOrderLocationSetup;
  gstSaleInvcumBOSArray: GstSaleInvCumBosDto[] = [];
  stateList: State[] = [];
  districtList: NameWithIdDto[] = [];
  cityList: NameWithIdDto[] = [];
  deliveryDetailsList: any[] = [];

  productOrderSummary: ProductOrderSummary = new ProductOrderSummary();
  gstSaleInvcumBOS: GstSaleInvCumBosDto = new GstSaleInvCumBosDto();

  //MapFor Google Map
  latitudeMap: number;
  longitudeMap: number;
  zoom: number;
  addressMap: string;
  private geoCoder = new google.maps.Geocoder();
  center: google.maps.LatLngLiteral = { lat: 28.6139, lng: 77.2090, };
  markerPosition: google.maps.LatLngLiteral = { lat: 28.6139, lng: 77.2090, };
  mapOptions: google.maps.MapOptions;
  @ViewChild("map", { static: true }) map: any;
  @ViewChild("search", { static: false }) search: ElementRef;
  markerOptions: google.maps.MarkerOptions = {
    draggable: true
  };
  public searchElementRef: ElementRef;

  private stateSubcription: Subscription;
  private districtListSubscription: Subscription;
  private cityListSubscription: Subscription;
  private webOrderMinimumDateTimeSubcription: Subscription;
  private customerDeliveryDetailsSubcription: Subscription;
  private getDeliveryDetailsSubscription: Subscription;
  private deactivateDeliveryDetailSubscription: Subscription;
  private choosePicCodeSubscription: Subscription;

  constructor(
    private localStorage: LocalStorageService,
    private formBuilder: UntypedFormBuilder,
    private addressService: AddressService,
    private apiFactory: ApiFactoryEndPoints,
    private toastService: ToastService,
    public productService: ProductService,
    private navRoute: Router,
    // private storeService: StoreService,
    private productOrderSummaryService: ProductOrderSummaryServiceService,
    // public dialog: MatDialog,
    // private mapsAPILoader: MapsAPILoader,
    private ngZone: NgZone,
    private appConfig: AppConfigService
  ) {
  }

  ngOnInit() {
    // this.currentUrl = getWindow().location.hostname;
    this.currentUrl = window.location.host.replace(':', '');
    this.onCreateSetUp();
    this.companyCode = JSON.parse(this.localStorage.getItem("company_code"));
    this.deliveryPinCode = JSON.parse(this.localStorage.getItem("pincode_item"));
    this.deliveryLocation = JSON.parse(this.localStorage.getItem("delivery_location"));
    this.getProductOrderSummaryDetails();
    this.getStateList();
    this.getWebOrders();
    this.getWebOrdersArray();
    // Step 1: Load stored delivery data
    // const stored = this.localStorage.getDeliveryDetails();
    // console.log("Stored delivery details:", stored);
    // if (stored) {
    //   this.createSetUpForm.patchValue({
    //     pincode: stored.pincode,
    //     latitude: stored.latitude,
    //     longitude: stored.longitude,
    //   });

    //   this.latitudeMap = stored.latitude;
    //   this.longitudeMap = stored.longitude;
    //   this.deliveryPinCode = stored.pincode;
    // }

    // Step 3: Load delivery addresses
    this.getDeliveryDetails();
  }

  ngAfterViewInit() {
    this.initializeAutocomplete();      // Main map
  }

  ngOnDestroy(): void {

  }

  onCreateSetUp() {
    this.createSetUpForm = this.formBuilder.group({
      id: [""],
      customerName: ["", Validators.required],
      contactNo: ["", [Validators.required, Validators.pattern("[6-9]\\d{9}")]],
      email: [""],
      // email: ["", Validators.compose([Validators.required,Validators.pattern(/^(\d{10}|\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3}))$/),]),],
      deliveryDate: [""],
      deliveryTime: [""],
      plotNo: ["", Validators.required],
      street: ["", Validators.required],
      landMark: [""],
      pincode: ["", [Validators.required, Validators.pattern("^[1-9][0-9]{5}$")],],
      cityCode: ["", Validators.required],
      stateCode: ["", Validators.required],
      districtCode: ["", Validators.required],
      address: ["", Validators.required],
      logInCustomerEmail: [""],
      defaultAddress: [""],
      latitude: ["", Validators.required],
      longitude: ["", Validators.required],
    });
  }

  initializeAutocomplete() {
    if (!this.search) {
      setTimeout(() => this.initializeAutocomplete(), 200);
      return;
    }

    const input = this.search.nativeElement as HTMLInputElement;

    const autocomplete = new google.maps.places.Autocomplete(input, {
      types: ['geocode']  // you can change this
    });

    autocomplete.addListener('place_changed', () => {
      const place = autocomplete.getPlace();

      if (place.geometry && place.geometry.location) {
        const lat = place.geometry.location.lat();
        const lng = place.geometry.location.lng();

        this.center = { lat, lng };
        this.markerPosition = { lat, lng };
        this.ngZone.run(() => {
          this.createSetUpForm.patchValue({
            latitude: lat,
            longitude: lng
          });
        });
        // console.log('Selected place:', place);
        // console.log('Lat:', lat, 'Lng:', lng);
      }
    });
  }

  getProductOrderSummaryDetails() {
    this.productOrderSummary = this.productOrderSummaryService.getOrderSummary();
    if (this.productOrderSummary == undefined) {
      this.navRoute.navigate(["/cart-items"]);
    }
    // var deliveryDateTime: any = JSON.parse(this.localStorage.getItem("delivery_date"));
    // var mtoOrder: any = JSON.parse(this.localStorage.getItem("mto_order"));

    // console.log(deliveryDateTime)
    // console.log(moment(deliveryDateTime).format("hh:mm a"))

    // if (mtoOrder) {
    //   this.disableDate = true;
    //   this.disableTime = true;
    // }
    // else {
    //   this.disableDate = false;
    //   this.disableTime = false;
    // }

    // this.createSetUpForm.patchValue({
    //   deliveryDate: moment(deliveryDateTime).format("YYYY-MM-DD"),
    //   deliveryTime: moment(deliveryDateTime).format("hh:mm a"),
    // });
  }

  getStateList() {
    this.stateSubcription = this.addressService.getStateList().subscribe((data) => {
      this.stateList = data.filter(state => state.stateName === 'Odisha');
      if (this.stateList.length == 1) {
        this.createSetUpForm.get('stateCode').setValue(this.stateList[0].refNo);
        this.onStateSelect(this.stateList[0].refNo);
      }
    });
  }

  getWebOrders() {
    this.gstSaleInvcumBOS = this.productOrderSummaryService.getWebOrder();
    // if (this.gstSaleInvcumBOS.details.length != 0) {
    //   this.deliveryDate = new Date(this.gstSaleInvcumBOS.details[0].deliveryDate);
    //   this.deliveryTime = this.gstSaleInvcumBOS.details[0].deliveryTime;
    // }
  }

  getWebOrdersArray() {
    this.gstSaleInvcumBOSArray = this.productOrderSummaryService.getWebOrderArray();
    // if (this.gstSaleInvcumBOSArray != undefined) {
    //   this.deliveryDate = new Date(this.gstSaleInvcumBOS.details[0].deliveryDate);
    //   this.deliveryTime = this.gstSaleInvcumBOS.details[0].deliveryTime;
    // }
  }

  getDeliveryDetails() {
    this.googleCustomer = JSON.parse(this.localStorage.getItem("google_loggedIn_details"));
    if (this.googleCustomer?.email != null) {
      this.getDeliveryDetailsSubscription = this.addressService
        .getDeliveryDetails(this.apiFactory.getDeliveryDetailsByCustomerCode, this.googleCustomer.refNo)
        .subscribe((data) => {
          if (data.length > 0) {
            this.deliveryDetailsList = data;
            this.showDeliveryDiv = true;
            this.deliveryListWithAddOption;

            // if (stored) {
            //   // console.log("Stored Delivery Details:", stored);

            //   data.forEach((item, index) => {
            //     // console.log(`Checking item at index ${index}`);
            //     // console.log('Item.latitude:', Number(item.latitude), 'Stored.latitude:', Number(stored.latitude));
            //     // console.log('Item.longitude:', Number(item.longitude), 'Stored.longitude:', Number(stored.longitude));
            //     // console.log('Item.shippingPinCode:', Number(item.shippingPinCode), 'Stored.pincode:', Number(stored.pincode));

            //     const latMatch = Number(item.latitude) === Number(stored.latitude);
            //     const lngMatch = Number(item.longitude) === Number(stored.longitude);
            //     const pinMatch = Number(item.shippingPinCode) === Number(stored.pincode);

            //     // console.log(`Match status -> lat: ${latMatch}, lng: ${lngMatch}, pin: ${pinMatch}`);
            //   });

            //   const matchedIndex = data.findIndex(item =>
            //     Number(item.latitude) === Number(stored.latitude) &&
            //     Number(item.longitude) === Number(stored.longitude) &&
            //     Number(item.shippingPinCode) === Number(stored.pincode)
            //   );

            //   console.log("Matched Index:", matchedIndex);

            //   if (matchedIndex !== -1) {
            //     this.onDeliveryDetailsClick(data[matchedIndex], matchedIndex);
            //   }
            // }


          } else {
            this.showDeliveryDiv = false;
          }
        });
    }
  }

  get deliveryListWithAddOption() {
    return [...this.deliveryDetailsList, { isNew: true }];
  }

  onStateSelect(stateCode: number) {
    this.districtListSubscription = this.addressService.getDistrictByStateCode(this.apiFactory.getDistrictListByStateCode, stateCode).subscribe((data) => {
      this.districtList = data;
    });
  }

  onDistrictSelect(districtCode: number) {
    this.cityListSubscription = this.addressService.getCitysByDistrictCode(this.apiFactory.getCityListByDistrictCode, districtCode).subscribe((data) => {
      this.cityList = data;
    });
  }

  onDeliveryDetailsClick(deliveryDetail: any, index: number) {
    if (deliveryDetail.isNew) {
      this.toogle = index;
      this.createSetUpForm.reset();
      this.createSetUpForm.enable(); // enable for new entry
      this.createSetUpForm.get('pincode').setValue(this.deliveryPinCode);
      return;
    }

    if (index === this.toogle) {
      this.toogle = null;
      this.createSetUpForm.reset();
      this.createSetUpForm.get('pincode').setValue(this.deliveryPinCode);
      this.createSetUpForm.enable();
    } else {
      this.toogle = index;
      this.onStateSelect(deliveryDetail.shippingCity?.district?.state?.refNo);
      this.onDistrictSelect(deliveryDetail.shippingCity?.district?.refNo);
      this.createSetUpForm.patchValue({
        id: deliveryDetail.refNo,
        customerName: deliveryDetail.contactName,
        contactNo: deliveryDetail.contactMobile,
        email: this.googleCustomer.email,
        // deliveryDate: moment(deliveryDateTime).format("YYYY-MM-DD"),
        // deliveryTime: moment(deliveryDateTime).format("hh:mm a"),
        plotNo: deliveryDetail.shippingPlotNo,
        areaLocality: deliveryDetail.areaLocality,
        pincode: deliveryDetail.shippingPinCode,
        cityCode: deliveryDetail.shippingCityCode,
        stateCode: deliveryDetail.shippingCity?.district?.state?.refNo,
        districtCode: deliveryDetail.shippingCity?.district?.refNo,
        address: deliveryDetail.shippingAddress,
        street: deliveryDetail.shippingStreet,
        landMark: deliveryDetail.shippingLandMark,
        latitude: deliveryDetail.latitude,
        longitude: deliveryDetail.longitude,
        logInCustomerEmail: this.googleCustomer.email,
        defaultAddress: deliveryDetail.defaultAddress,
      });
      this.latitudeMap = deliveryDetail.latitude;
      this.longitudeMap = deliveryDetail.longitude;
      this.zoom = 2;
      this.getAddress(Number(this.latitudeMap), Number(this.longitudeMap));
      this.createSetUpForm.disable(); // make existing data non-editable
    }
  }

  changeColor(index: number) {
    this.toogle = index;
  }

  onCreateSetUpClick() {
    if (this.createSetUpForm.invalid) {
      this.toastService.showErrorToast("Invalid form");
      return;
    }
    // if (this.createSetUpForm.get("pincode").value != this.deliveryPinCode) {
    //   this.toastService.showErrorToast('Delivery available to this pincode ' + this.deliveryPinCode);
    //   return;
    // }

    this.refNo = this.createSetUpForm.get("id").value;
    this.customerName = this.createSetUpForm.get("customerName").value;
    this.contactNo = this.createSetUpForm.get("contactNo").value;
    this.pincode = this.createSetUpForm.get("pincode").value;
    this.cityCode = this.createSetUpForm.get("cityCode").value;
    this.stateId = this.createSetUpForm.get("stateCode").value;
    this.districtId = this.createSetUpForm.get("districtCode").value;
    this.address = this.createSetUpForm.get("address").value;
    this.email = this.createSetUpForm.get("email").value;
    this.plot = this.createSetUpForm.get("plotNo").value;
    this.street = this.createSetUpForm.get("street").value;
    this.landMark = this.createSetUpForm.get("landMark").value;
    this.latitude = this.createSetUpForm.get("latitude").value;
    this.longitude = this.createSetUpForm.get("longitude").value;
    this.stateName = this.stateList.filter(e => e.refNo == this.stateId)[0]?.stateName;
    this.cityName = this.cityList.filter(e => e.id == this.cityCode)[0]?.name;

    //For indivisual order
    if (this.gstSaleInvcumBOS && this.gstSaleInvcumBOS.details.length != 0) {
      this.gstSaleInvcumBOS.details.forEach((d) => {
        this.deliveryDate = new Date(d.deliveryDate);
        this.deliveryTime = d.deliveryTime;
      });

      this.deliveryDate.setHours(Number.parseInt(this.deliveryTime.split(":")[0]));
      this.deliveryDate.setMinutes(Number.parseInt(this.deliveryTime.split(":")[1]));

      var deliveryAddress: CustomerDeliveryAddress = new CustomerDeliveryAddress();

      deliveryAddress.refNo = this.refNo;
      deliveryAddress.contactName = this.customerName;
      deliveryAddress.contactMobile = this.contactNo;
      deliveryAddress.shippingPinCode = this.pincode;
      deliveryAddress.shippingCityCode = this.cityCode;
      deliveryAddress.shippingAddress = this.address;
      deliveryAddress.shippingPlotNo = this.plot;
      deliveryAddress.shippingLandMark = this.landMark;
      deliveryAddress.shippingStreet = this.street;
      deliveryAddress.email = this.email;
      deliveryAddress.stateCode = this.stateId;
      deliveryAddress.districtCode = this.districtId;
      deliveryAddress.deliveryDate = this.deliveryDate;
      deliveryAddress.latitude = this.latitude;
      deliveryAddress.longitude = this.longitude;
      deliveryAddress.stateName = this.stateName;
      deliveryAddress.cityName = this.cityName;
      deliveryAddress.customerCode = this.googleCustomer.refNo;

      this.productOrderSummaryService.setCustomerDeliveryAddress(deliveryAddress);
      this.gstSaleInvcumBOS.customerDeliveryAddress = deliveryAddress;
      this.productOrderSummaryService.setWebOrder(this.gstSaleInvcumBOS);
      this.productOrderSummary.deliveryAddress = deliveryAddress;
      this.productOrderSummaryService.setOrderSummary(this.productOrderSummary);
    }

    //For total order
    if (this.gstSaleInvcumBOSArray && this.gstSaleInvcumBOSArray.length != 0) {
      this.gstSaleInvcumBOSArray.forEach((e) => {
        e.details.forEach((d) => {
          this.deliveryDate = new Date(d.deliveryDate);
          this.deliveryTime = d.deliveryTime;
        });
        var deliveryAddress: CustomerDeliveryAddress = new CustomerDeliveryAddress();

        deliveryAddress.refNo = this.refNo;
        deliveryAddress.contactName = this.customerName;
        deliveryAddress.contactMobile = this.contactNo;
        deliveryAddress.shippingPinCode = this.pincode;
        deliveryAddress.shippingCityCode = this.cityCode;
        deliveryAddress.shippingAddress = this.address;
        deliveryAddress.shippingPlotNo = this.plot;
        deliveryAddress.shippingLandMark = this.landMark;
        deliveryAddress.shippingStreet = this.street;
        deliveryAddress.stateCode = this.stateId;
        deliveryAddress.districtCode = this.districtId;
        deliveryAddress.email = this.email;
        deliveryAddress.deliveryDate = this.deliveryDate;
        deliveryAddress.latitude = this.latitude;
        deliveryAddress.longitude = this.longitude;
        deliveryAddress.stateName = this.stateName;
        deliveryAddress.cityName = this.cityName;
        deliveryAddress.customerCode = this.googleCustomer.refNo;

        e.customerDeliveryAddress = deliveryAddress;
      });
      this.productOrderSummaryService.setWebOrderArray(this.gstSaleInvcumBOSArray);

      this.productOrderSummary.deliveryAddress = deliveryAddress;
      this.productOrderSummaryService.setOrderSummary(this.productOrderSummary);
    }

    this.createSetUpForm.patchValue({ logInCustomerEmail: this.googleCustomer.email, });
    this.customerDeliveryDetailsSubcription = this.addressService.insertDeliveryDetails(this.apiFactory.insertDeliveryDetailsApp, this.productOrderSummary.deliveryAddress)
      .subscribe((data) => {
        this.productOrderSummary.deliveryAddressRefNo = data.refNo;
        this.productOrderSummaryService.setOrderSummary(this.productOrderSummary);
        this.localStorage.setItem("last_delivery_address", JSON.stringify(this.productOrderSummary.deliveryAddress));
        this.toastService.showSuccessToast("Saved Successfully");
        this.navRoute.navigate(["/order-summary"]);
      });

    // this.dialog.open(GstinDialogComponent, {
    //   width: "350px",
    //   autoFocus: false,
    // });

    // this.webOrderMinimumDateTimeSubcription = this.addressService.getWebOrderMinimumDateTimeDetails().subscribe((data) => {
    //   this.webOrderMinimumDateTimeList = data;

    //   //function for checking deleivery duartion
    //   this.deliveryDate.setHours(
    //     Number.parseInt(this.deliveryTime.split(":")[0])
    //   );
    //   this.deliveryDate.setMinutes(
    //     Number.parseInt(this.deliveryTime.split(":")[1])
    //   );

    //   var orderDuration = new Date();
    //   orderDuration.setHours(orderDuration.getHours() + Number.parseInt(
    //     this.webOrderMinimumDateTimeList.deliveryTime.split(":")[0]));
    //   orderDuration.setMinutes(orderDuration.getMinutes() + Number.parseInt(
    //     this.webOrderMinimumDateTimeList.deliveryTime.split(":")[1]));

    //   if (orderDuration.getTime() >= this.deliveryDate.getTime()) {
    //     this.toastService.showErrorToast("Cannot place order please select Date After " +
    //       this.webOrderMinimumDateTimeList.deliveryTime.split(":")[0] + " " + "Hour");
    //   } else {
    //     var deliveryAddress: CustomerDeliveryAddress = new CustomerDeliveryAddress();
    //     deliveryAddress.customerName = this.customerName;
    //     deliveryAddress.mobileNo = this.contactNo;
    //     deliveryAddress.pinCode = this.pincode;
    //     deliveryAddress.city = this.cityName;
    //     deliveryAddress.districtCode = this.districtId;
    //     deliveryAddress.houseAddress = this.address;
    //     deliveryAddress.email = this.email;
    //     deliveryAddress.deliveryDate = this.deliveryDate;
    //     console.log(this.deliveryTime)
    //     if (this.deliveryTime.split(" ")[1] == 'pm') {
    //       deliveryAddress.deliveryDate.setHours(
    //         Number.parseInt(this.deliveryTime.split(":")[0]) + 12);
    //     }
    //     else {
    //       deliveryAddress.deliveryDate.setHours(
    //         Number.parseInt(this.deliveryTime.split(":")[0])
    //       );
    //     }
    //     deliveryAddress.deliveryDate.setMinutes(
    //       Number.parseInt(this.deliveryTime.split(":")[1])
    //     );

    //     console.log(deliveryAddress)
    //     deliveryAddress.plotNo = this.plot;
    //     deliveryAddress.areaLocality = this.locality;
    //     deliveryAddress.stateCode = this.stateId;
    //     this.gstSaleInvcumBOS.customerDeliveryAddress = deliveryAddress;
    //     this.productOrderSummaryService.setWebOrder(this.gstSaleInvcumBOS);

    //     var deliveryAddress: CustomerDeliveryAddress = new CustomerDeliveryAddress();
    //     deliveryAddress.customerName = this.customerName;
    //     deliveryAddress.mobileNo = this.contactNo;
    //     deliveryAddress.pinCode = this.pincode;
    //     deliveryAddress.city = this.cityName;
    //     deliveryAddress.districtCode = this.districtId;
    //     deliveryAddress.houseAddress = this.address;
    //     deliveryAddress.email = this.email;
    //     deliveryAddress.plotNo = this.plot;
    //     deliveryAddress.areaLocality = this.locality;
    //     deliveryAddress.deliveryDate = this.deliveryDate;
    //     this.productOrderSummary.deliveryAddress = deliveryAddress;

    //     this.productOrderSummaryService.setOrderSummary(this.productOrderSummary);

    //     this.createSetUpForm.patchValue({
    //       logInCustomerEmail: this.googleCustomer.email
    //     })
    //     console.log(this.createSetUpForm.value)
    //     this.customerDeliveryDetailsSubcription = this.addressService.insertDeliveryDetails(this.apiFactory.insertDeliveryDetails, this.createSetUpForm).subscribe((data) => {
    //       this.toastService.showSuccessToast("Saved Successfully");
    //     });
    //     this.dialog.open(GstinDialogComponent, {
    //       width: "350px",
    //     });
    //   }
    // });
  }

  // choosePincode() {
  //   let pincode = this.createSetUpForm.get("pincode").value;
  //   if (pincode.toString().length === 6) {
  //     this.validatePinCode(pincode);
  //   }
  // }

  // validatePinCode(pin: number) {
  //   if (this.deliveryPinCode) {
  //     if (pin == this.deliveryPinCode) {
  //       this.createSetUpForm.get("latitude").reset();
  //       this.createSetUpForm.get("longitude").reset();
  //     } else {
  //       this.toastService.showErrorToast('Delivery available to this pincode ' + this.deliveryPinCode);
  //       return;
  //     }
  //   } else {
  //     this.toastService.showErrorToast('Give Delivery Pincode');
  //   }
  // }

  getAddress(latitude, longitude) {
    /* 🔥 Always sync map */
    this.center = { lat: latitude, lng: longitude };
    this.markerPosition = { lat: latitude, lng: longitude };

    this.toastService.clearAllToast();
    this.geoCoder.geocode({ location: { lat: latitude, lng: longitude } }, (results, status) => {
      if (status === "OK") {
        if (results[0]) {
          this.zoom = 12;
          this.addressMap = results[0].formatted_address;

          const addressComponents = results[0].address_components;
          let pincode = '';

          // Check if pincode is present
          const hasPincode = addressComponents.some(comp => comp.types.includes('postal_code'));
          if (!hasPincode) {
            this.resetMapFields('Your location does not have a valid pincode.');
            return;
          }

          // Extract Pincode
          for (let component of addressComponents) {
            if (component.types.includes('postal_code')) {
              pincode = component.long_name;
              console.log('deliveryPinCode:', this.deliveryPinCode);
              console.log('Extracted pincode:', pincode);
              // if (String(pincode) !== String(this.deliveryPinCode)) {
              //   this.resetMapFields('Your location does not match the PIN: ' + this.deliveryPinCode);
              //   return;
              // }
              break;
            }
          }
        } else {
          this.toastService.showErrorToast("No results found");
        }
      } else {
        this.toastService.showErrorToast("Geocoder failed due to: " + status);
      }
    });
  }

  resetMapFields(message: string) {
    this.createSetUpForm.get("latitude").reset();
    this.createSetUpForm.get("longitude").reset();
    this.toastService.showErrorToast(message);
  }

  fetchCurrentLoc() {
    if (!this.createSetUpForm.enabled) {
      return; // prevent fetch in view-only mode
    }
    if (!("geolocation" in navigator)) {
      this.toastService.showErrorToast("Geolocation not supported");
      return;
    }

    this.toastService.showWarningToast("Fetching current location...");

    let watchId = navigator.geolocation.watchPosition(
      (position) => {

        this.latitudeMap = position.coords.latitude;
        this.longitudeMap = position.coords.longitude;
        this.zoom = 12;

        this.createSetUpForm.patchValue({
          latitude: this.latitudeMap,
          longitude: this.longitudeMap,
        });

        this.getAddress(this.latitudeMap, this.longitudeMap);

        // Stop watching after first successful fetch
        navigator.geolocation.clearWatch(watchId);
      },
      (error) => {
        console.error("Geolocation error: ", error);
        let message = "";

        switch (error.code) {
          case error.PERMISSION_DENIED:
            message = "Permission denied. Enable location.";
            break;
          case error.POSITION_UNAVAILABLE:
            message = "Location unavailable. Try again.";
            break;
          case error.TIMEOUT:
            message = "Request timed out.";
            break;
          default:
            message = "Unknown location error.";
        }

        this.toastService.showErrorToast(message);
        navigator.geolocation.clearWatch(watchId);
      },
      {
        enableHighAccuracy: true,
        timeout: 20000,
        maximumAge: 0
      }
    );
  }

  onMarkerDrag(event: google.maps.MapMouseEvent) {
    if (event.latLng) {
      this.markerPosition = {
        lat: event.latLng.lat(),
        lng: event.latLng.lng()
      };
    }
  }

  onDeleteDeliveryDetails(deliveryDetail: any, index: number) {
    let headingMessage = "Are you sure want to delete the delivery details?";
    // const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
    //   height: '152px',
    //   width: '346px',
    //   data: { heading: headingMessage }
    // });

    // dialogRef.afterClosed().subscribe(result => {
    //   if (result) {
    //     this.deactivateDeliveryDetailSubscription = this.addressService.deactivateDeliveryDetails(this.apiFactory.deactivateDeliveryDetails, deliveryDetail.refNo).subscribe((data) => {
    //       if (data) {
    //         this.toastService.showSuccessToast("Delivery details deleted successfully");
    //         this.createSetUpForm.reset();
    //         this.getDeliveryDetails();
    //         this.toogle = null;
    //       }
    //     });
    //   }
    // })
  }

  choosePincode() {
    this.pincode = this.createSetUpForm.get("pincode").value;

    if (this.pincode.toString().length === 6) {
      // this.onLocationDetailsSubscription = this.pinDialogService.getLocationDetailsByPincodeAndlatlng(this.pincode, this.url, this.latitudeMap, this.longitudeMap).subscribe((data) => {
      //   console.log(data);
      //   if (data.length > 0) {
      //     this.showClickButton = false;
      //     this.showSubmitBtn = true;
      //     this.showToast = false;
      //     this.locationSetupList = data;

      //     this.locationSetupList.forEach((element) => {
      //       if (element.address.length > 40) {
      //         let firstAdd: string = "";
      //         const adds = element.address.split(",");
      //         if (adds.length > 0) {
      //           for (let i = 0; i < adds.length; i++) {
      //             if (firstAdd.length + adds[i].length < 40) {
      //               firstAdd += adds[i] + ", ";
      //             }
      //           }
      //         }
      //         if (firstAdd.length > 0) {
      //           element.address1 = firstAdd;
      //           element.address2 = element.address.substring(
      //             firstAdd.length - 1,
      //             element.address.length
      //           );
      //         }
      //       } else {
      //         element.address1 = element.address;
      //       }
      //     });
      //     if (this.locationSetupList.length == 1) {
      //       this.onSelectLocation(0);
      //     }
      //   } else {
      //     this.showClickButton = true;
      //     this.showToast = true;
      //     this.locationSetupList = [];
      //     this.selectedIndex = null;
      //     this.saveWebUserInfo();
      //   }
      // });
      this.choosePicCodeSubscription = this.productService.checkPincode(this.apiFactory.checkPincode, this.pincode, this.currentUrl)
        .subscribe((isValidPincode) => {
          if (isValidPincode) {
            // this.handleValidPincode(locData);
          } else {
            // this.toastService.showErrorToast("Invalid Pincode Or Not Allowed");
            this.toastService.showErrorToast('Delivery not available to this pincode ' + this.pincode);
            this.createSetUpForm.get("latitude").reset();
            this.createSetUpForm.get("longitude").reset();
            this.createSetUpForm.patchValue({ pincode: "" });
          }
        });
    }
  }

  // In your product-delivery-address.component.ts file
  addNewAddress() {
    // Clear the form to add a new address
    this.createSetUpForm.reset();

    // Set toogle to the last index to select the "Add New Address" card
    this.toogle = this.deliveryListWithAddOption.length - 1;

    // You might also want to focus on the first form field
    // Optional: scroll to form section
    setTimeout(() => {
      const formSection = document.querySelector('form');
      if (formSection) {
        formSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }, 100);
  }
  // Add to your component class
  activeTab: 'addresses' | 'new' = 'addresses';

}